export const PAGE = 'page';
export const PAGE_PAGES = 'PAGE_PAGES';
